import React from "react";
import LeaveManager from "../../components/attendance/LeaveManager";

export default function StudentLeavePage() {
  return <LeaveManager subjectType="STUDENT" title="Student Leave Entry" />;
}
